import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch } from '@/store/hooks'
import { clearTokens, saveTokens, saveCurrentAccount, initializeAuth } from '@/store/authSlice'
import { clearWorkspace } from '@/store/workspaceSlice'
import { AccountService } from '@/api'

/**
 * 어드민 패널에서 특정 사용자로 로그인(impersonate)할 때 사용되는 페이지.
 * URL 파라미터로 전달받은 JWT 토큰으로 기존 세션을 교체한다.
 */
export default function ImpersonatePage() {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const processed = useRef(false)

  useEffect(() => {
    if (processed.current) return
    processed.current = true

    const run = async () => {
      const params = new URLSearchParams(window.location.search)
      const accessToken = params.get('access_token')
      const refreshToken = params.get('refresh_token')

      if (!accessToken || !refreshToken) {
        navigate('/', { replace: true })
        return
      }

      // 1. 기존 로그인 데이터 정리
      clearTokens()
      dispatch(clearWorkspace())

      // 2. 새 토큰 저장
      saveTokens(accessToken, refreshToken)

      // 3. 사용자 정보 조회 후 저장
      try {
        const account = await AccountService.appsAccountViewsGetCurrentAccount()
        saveCurrentAccount(account)
      } catch {
        // 사용자 정보 조회 실패해도 토큰은 이미 저장됨
        // initializeAuth에서 다시 시도됨
      }

      // 4. URL에서 토큰 제거 (보안)
      window.history.replaceState({}, '', '/impersonate')

      // 5. Redux 인증 상태 초기화 (워크스페이스 로드 포함)
      await dispatch(initializeAuth())

      // 6. 메인 페이지로 이동
      navigate('/', { replace: true })
    }

    run()
  }, [dispatch, navigate])

  return null
}
